import React from "react";
import { Link } from "react-router-dom";
import "./Confirmation.css";

const Confirmation: React.FC = () => {
  return (
    <div className="confirmation-page">
      <div className="confirmation-content">
        <div className="confirmation-main">
          <div className="confirmation-program-title">
            City of New Orleans, E-Bike Incentive Program
          </div>
          <div className="confirmation-divider"></div>

          <div className="confirmation-success-header">
            <div className="check-circle-container">
              <img
                src="/images/check-circle.svg"
                alt="Check circle"
                className="check-circle-icon"
              />
            </div>
            <h1 className="application-submitted-title">
              Application Submitted
            </h1>
          </div>

          <p className="confirmation-thank-you">
            Thank you for your interest in the City of New Orleans, Louisiana's
            E-Bike Incentive Program. We have received your application.
          </p>

          <h2 className="whats-next-title">WHAT'S NEXT</h2>

          <p className="next-steps-description">
            <span>
              Your application is being reviewed. You will be notified of a
              decision within 2-4 weeks. Until then, you can view{" "}
            </span>
            <Link to="/shops" className="confirmation-link">
              qualifying e-bike retailers
            </Link>
            <span>, learn more </span>
            <Link to="/about" className="confirmation-link">
              about the program
            </Link>
            <span>, and see answers to </span>
            <Link to="/faqs" className="confirmation-link">
              frequently asked questions
            </Link>
            <span>
              . You can also return to this site any time to check the{" "}
            </span>
            <Link to="/status" className="confirmation-link">
              status of your application
            </Link>
            <span>.</span>
          </p>
        </div>

        <div className="confirmation-image-container">
          <img
            src="/images/final-submit.webp"
            alt="E-bike confirmation"
            className="confirmation-bike-image"
          />
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
